import { Vector3 } from 'three';

const THREE = window.THREE;

const vec3Temp = new THREE.Vector3();
const vec3Temp2 = new THREE.Vector3();
const vec3Temp3 = new THREE.Vector3();

// const matHelper = new THREE.MeshBasicMaterial({
//     depthTest: false,
//     depthWrite: false,
//     transparent: true,
//     side: THREE.DoubleSide,
//     fog: false
// });

const matHelper = new THREE.LineBasicMaterial( { 
    depthTest: false,
    depthWrite: false,
    transparent: true,
    // side: THREE.DoubleSide,
    fog: false,
    color: 0xffffff
});
const LinePool = [];
function createLine()
{
    let n = LinePool.length;
    if( n > 0 ) {
        let o = LinePool[n-1];
        o.visible = true;
        LinePool.splice(n-1, 1);
        return o;
    }

     //绘制交叉线
     const geometry = new THREE.BufferGeometry();
     geometry.setAttribute('position', new THREE.Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1], 3 ) );    
     let ln =  new THREE.Line( geometry, matHelper);
     ln.renderOrder = 1000;
     
     return ln;
}

function deleteLine( ln ) {
    ln.visible = false;
    if( LinePool.indexOf(ln) == -1 ) LinePool.push( ln );
}

export default class Line {
    static textFont = null;

    constructor(app){
        this.app = app;
        this.visible = true;
        this.lineSeg = 1;//默认段数1
        this.wsendPoint = new THREE.Vector3();
        this.objsSeg = [];

    }
    
    deinit() {
        // if( this.line ) this.app.scene.remove( this.line );
        // this.line = null;
        if( this.line )  this.line.visible = false;
        if( this.lastTextObj ) this.lastTextObj.visible = false;
        this.objsSeg.forEach(e=>{
            e.visible = false;
        })
    
    }

    changeVisible( visible ) {
        this.visible = (visible == 1);
        this.line.visible = this.visible;
        if( this.lastTextObj ) this.lastTextObj.visible = this.visible;

        if( this.lastEndPoint ) {
            this.lastText = 0;
            this.updateEndPoint( this.lastEndPoint );
        }
        
        visible = this.visible;
        this.objsSeg.forEach(e=>{
            e.visible = visible;
        });
    }

    clear(){
        this.deinit();
        this.startPoint = null;
        this.endPoint = null;
        this.objsSeg.forEach(e=>{
            this.app.scene.remove( e );
        });


    }
    updateLineSeg( seg )  {
        this.lineSeg = parseInt( seg );

        this.updateEndPoint( this.lastEndPoint );

        if( this.endPoint ) {
            this.updeteLineSegObj();
        }
    }

    init()
    {
        // if( this.line ) return;
        // let scene = this.app.scene;

        // const geometry = new THREE.BufferGeometry();
        // geometry.addAttribute( 'position', new THREE.Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1], 3 ) );    
        // let line =  new THREE.Line( geometry, matHelper);
        // scene.add( line ) 
        // this.lineGeo = geometry.getAttribute('position');

        // this.line = line;
        // line.visible = false;

        // scene.add( line );
    }

    updateStarPoint( point )
    {
        //线段已经生成，直接返回
        if( this.endPoint ) return;

        if( this.startPoint ) {//更新最后一个点
            this.updateEndPoint( point );

            this.endPoint = point;
            return;
        }
        let scene = this.app.scene;


        if( !this.line ) {
            this.line = createLine();
            this.lineGeo = this.line.geometry.getAttribute("position");
            scene.add( this.line );
        }

        this.startPoint = point;

        point.getWorldPosition(vec3Temp);

        this.wstartPoint = vec3Temp.clone();
        this.lineGeo.setXYZ(0, vec3Temp.x, vec3Temp.y, vec3Temp.z);
        this.line.visible = this.visible;
     }

     updeteLineSegObj(){
        if( !this.wstartPoint || !this.visible || !this.startPoint || !this.lastEndPoint  ) return;

        let scene = this.app.scene;
       
        this.objsSeg.forEach(el=>{
            scene.remove( el );
            if( el.type == 'Line') {
                deleteLine( el );
            }
        });
        this.objsSeg = [];

        let objs = this.objsSeg;
        //根据段数进行划分
        let n = this.lineSeg;
        let total =  n + 1;
        let wstartPoint = this.wstartPoint;
        let wsendPoint = this.wsendPoint;
        vec3Temp2.subVectors(wsendPoint, wstartPoint);
        vec3Temp2.normalize();
        vec3Temp3.subVectors( this.app.activeCamera.position, wstartPoint);
        vec3Temp3.normalize();

        vec3Temp2.crossVectors(vec3Temp2, vec3Temp3);

        // let dot = vec3Temp2.dot( vec3Temp3 );
        // console.log( dot );
        // let isVert = (dot < 1.0 && dot > 0.65) || (dot<-0.65 && dot > -1.0);
        // console.log( isVert );

        for( let i=0; i < total; i++){
            let per = i * 1.0 / n;
            vec3Temp3.lerpVectors(wstartPoint, wsendPoint, per);
            vec3Temp.copy( vec3Temp3 );

            //绘制索引
            let needDrawIndex = true;
            if( total > 12 && i%2==1 ) needDrawIndex = false;
            if( total > 28 ) {
                needDrawIndex = (i % 3 == 0);
            }
            if( total > 38 ) {
                let m = Math.ceil(total / 10);
                needDrawIndex = (i % m == 0);
            }

            if( needDrawIndex )  {
                let obj = this.createText( i + "", 0.01);
                vec3Temp3.addScaledVector(vec3Temp2, 0.03);
                obj.position.copy( vec3Temp3 );
    
                objs.push( obj );
                scene.add( obj );
            }

            //绘制交叉线
            let ln = createLine();
            let pos = ln.geometry.getAttribute('position');
            vec3Temp3.copy( vec3Temp );

            let offset = needDrawIndex?0.015:0.01;

            vec3Temp3.addScaledVector(vec3Temp2, offset);
            pos.setXYZ(0, vec3Temp3.x, vec3Temp3.y, vec3Temp3.z);
           
            vec3Temp3.copy( vec3Temp );
            vec3Temp3.addScaledVector(vec3Temp2, -1.0*offset);

            pos.setXYZ(1, vec3Temp3.x, vec3Temp3.y, vec3Temp3.z);
            pos.needsUpdate = true;
            ln.needsUpdate = true;
            objs.push( ln );
            scene.add( ln );
        }
        // console.log(objs.length);
    }

    updateEndPoint(point)
    {
        if( !this.wstartPoint || !this.visible || !this.startPoint || this.endPoint ) return;

        point.getWorldPosition(vec3Temp);
        this.lineGeo.setXYZ(1, vec3Temp.x, vec3Temp.y,vec3Temp.z);
        this.lineGeo.needsUpdate = true;
        // this.line.visible = true;
        this.wsendPoint.copy( vec3Temp );

        let dist = vec3Temp.distanceTo( this.wstartPoint ) * 100.0;
        let t = dist.toFixed(1);

        // console.log( t );
        this.lastEndPoint = point;

        if( this.lastText == t ) return;

        this.lastText = t;
        // let scene = this.app.scene;
        // if( this.lastTextObj ) {
        //     scene.remove( this.lastTextObj );
        // }
        // this.lastTextObj = this.createText( t  + "cm");

        // let wstartPoint = this.wstartPoint;
        // let wsendPoint = this.wsendPoint;
        // vec3Temp2.subVectors(wsendPoint, wstartPoint);
        // vec3Temp2.normalize();
        // vec3Temp3.subVectors( this.app.activeCamera.position, wstartPoint);
        // vec3Temp3.normalize();
        // vec3Temp2.crossVectors(vec3Temp2, vec3Temp3);

        // vec3Temp3.subVectors( wsendPoint, wstartPoint);
        // vec3Temp3.normalize();
        // vec3Temp.addScaledVector( vec3Temp3, 0.01);
        // vec3Temp.addScaledVector(vec3Temp2, -0.03);
        // // vec3Temp.y -= 0.05;
        // this.lastTextObj.position.copy( vec3Temp );

        // scene.add( this.lastTextObj );

        // console.log(  scene.children.length );

        this.updeteLineSegObj();
    }

    createText(text, size=0.02, height=0.001)
    {
        console.log( text );

        let textGeo = new THREE.TextGeometry(text, {
            font: Line.textFont,
            size,
            height,
            curveSegments: 4
        });

        let txt = new THREE.Mesh(textGeo, matHelper);
        txt.rotateY( -Math.PI / 2.0 );
        // txt.position.set(0,2.1,0);

        let camera = this.app.activeCamera;

        txt.lookAt( camera.position );
        return txt;
    }

    static loadFont() {
        return new Promise((resolve, reject)=>{
            var loader = new THREE.FontLoader();
            loader.load( require('../../assets/droid_sans_mono_regular.typeface.fjson'), function ( response) {
                Line.textFont = response;
                resolve( response );
            } );
        })
    }
}

